<template>
  <div class="d-flex justify-start edn-mimic">
    <v-text-field
      @focus="editingFromOutside = false"
      :disabled="$attrs.rdonly === '' || $attrs.rdonly"
      :filled="$attrs.rdonly === '' || $attrs.rdonly"
      :id="$attrs.id"
      ref="txtField"
      v-if="!linkMode"
      :label="$attrs.label"
      :rdonly="$attrs.rdonly"
      :prepend-inner-icon="getPrepIcon"
      :append-icon="getAppendedIcon"
      type="text"
      @update:error="isReady($event)"
      v-model="Value"
      v-bind="$attrs"
      v-on="$listeners"
      :rules="rules || $attrs.rules"
      :clearable="!$attrs.rdonly === '' || $attrs.rdonly"
      :class="[($attrs.rdonly === '' || $attrs.rdonly) ? 'text--disabled' : '', 'iris-mimic']"
      class="flex-grow-1"
      autocomplete="off"
      @blur="isMimic();editingFromOutside = true"
      :error="pattern && !pattern.test(Value) && Value != ''"
      :error-messages="getErrorMessages"
    >
      <template v-slot:append v-if="$attrs.tooltip">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" style="cursor:pointer;">mdi-help-circle-outline</v-icon>
          </template>
          {{ $attrs.tooltip }}
        </v-tooltip>
      </template>
    </v-text-field>
    <edn-goto
      @validationMode="getValidationMode($event)"
      :pattern="pattern"
      :rules="rules"
      @focused="focusOnInput($event)"
      :prepIcon="getPrepIcon"
      v-else
      @edit="isMimic(false)"
      :linkMode="type"
      :label="$attrs.label"
    >
      <template v-slot:editable>
        {{ Value }}
      </template>
    </edn-goto>
    <slot name="outer-icon"></slot>
  </div>
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import { ednRegex } from './mixins/ednRegex'
import { ednSocialIcon } from './mixins/ednSocialIcon'
import { ednValue } from './mixins/ednValue'

export default {
  name: 'ednMimic',
  inheritAttrs: false,
  mixins: [ednRequired, ednRegex, ednSocialIcon, ednValue],
  props: {
    type: {
      type: String,
      default: () => 'url',
    },
    value: null
  },
  data() {
    return {
      valid: null,
      readyToConvert: true,
      linkMode: false,
      focused: false,
      sInvalidMsg:'',
      oInvalidMsg: {
        mail: 'Vous devez entrer une adresse mail valide. ',
        url: 'Vous devez entrer une url valide.',
        phone: 'Vous devez entrer un numéro de téléphone valide.',
      },
      editingFromOutside: true
    }
  },
  mounted() {
    //Définit quel message va être présenté lors d'une erreur de regex en fonction du type de champs
    this.sInvalidMsg = this.oInvalidMsg[this.type]
    // Permet de vérifier que le champs a une valeur correcte , sans avoir à éditer le champs pour connaître l'information. Si le champs a une valeur correcte on affiche le lien.
    this.linkMode = this.pattern && this.pattern.test(this.Value) && this.Value != '' && this.Value && !this.$attrs.rdonly;
    this.readyToConvert = this.pattern && this.pattern.test(this.Value) && this.Value != '';
  },
  computed: {
    /**
     * Récupère l'icône si le champs est en lecture seule
    */
    getAppendedIcon(){
      return this.$attrs.rdonly === '' || this.$attrs.rdonly ? 'mdi-lock': ''
    },
    /**
     * Si la valeur du champs au départ est invalide, on affiche l'erreur 
     */
    getErrorMessages(){
      return this.isInvalid() ? this.oInvalidMsg[this.type] : ''
    }
  },
  methods: {
    /**
     * Vérifie si le contenu ne respecte pas la regex du champs
     */
    isInvalid(){
      return this.pattern && !this.pattern.test(this.Value) && this.Value != ''
    },
    /**
     * Détermine si le champs est prêt à être converti en lien ( composant irisMimic)
     */
    isReady(e) {
      this.readyToConvert = !e
      if(this.editingFromOutside && !this.$attrs.rdonly)
        this.linkMode = !e
    },
    /**
     * Permet de mettre le champs en focus via la ref
     */
    focusOnInput() {
      if(this.$refs.txtField) this.$refs.txtField.focus()
    },
    /**
     * Au blur, on vérifie que le champs peut être convertie en lien ( linkMode)
     * @param {any} bVal permet de forcer le changement du lien vers le champs en édition ( au clic sur le stylo à droite)
     */
    isMimic(bVal = true) {
      if(this.Value) this.linkMode = bVal && this.Value.length > 0 && this.readyToConvert
      if (this.Value && this.arrSocial && this.arrSocial.find(x => this.Value.includes(x)))
        this.socialIcon = 'mdi-' + this.arrSocial.find(x => this.Value.includes(x))
      else this.socialIcon = ''
    },
    /**
     * A la réception de l'emit valdidationMode provenant de l'enfant, on récupère si oui ou non la valeur respecte la regex. Si non, on repasse en édition
     */
    getValidationMode(e){   
      this.linkMode = e
      this.readyToConvert = e
    }
  },
}
</script>
<style lang="scss">
div {
	&.v-input--is-readonly {
		pointer-events: none;
		user-select: none;
	}
	&.edn-mimic {
		& > div {
			flex-grow: 1;
		}
	}
}
.v-application {
	.error--text {
		.v-input {
			input {
				color: var(--v-error-base) !important;
			}
		}
	}
}
.v-application  .edn-mimic.iris-rdonly .v-input input{
  text-overflow:ellipsis;
}

</style>
